import { Box, Button, Typography } from '@mui/material';

export type TipoCarga =
  | 'hpg'
  | 'coprocultivo'
  | 'baermann'
  | 'sedimentacion_fh'
  | 'ectoparasitos';

interface AnalisisToolbarProps {
  onCargar: (tipo: TipoCarga) => void;
}

function Separador(): JSX.Element {
  return (
    <Box
      sx={{ width: '1px', height: 18, bgcolor: 'divider', alignSelf: 'center', flexShrink: 0 }}
    />
  );
}

export function AnalisisToolbar({ onCargar }: AnalisisToolbarProps): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        alignItems: 'center',
        bgcolor: 'grey.100',
        p: '10px 12px',
        borderRadius: 1,
        mb: 2,
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ mr: 0.5, whiteSpace: 'nowrap' }}>
        Cargar:
      </Typography>

      <Button size="small" variant="outlined" onClick={() => onCargar('hpg')}>
        HPG
      </Button>

      <Separador />

      <Button size="small" variant="outlined" onClick={() => onCargar('coprocultivo')}>
        Coprocultivo
      </Button>

      <Separador />

      <Button size="small" variant="outlined" onClick={() => onCargar('baermann')}>
        Baermann
      </Button>

      <Separador />

      <Button size="small" variant="outlined" onClick={() => onCargar('sedimentacion_fh')}>
        Sedimentación Fh
      </Button>

      <Separador />

      <Button size="small" variant="outlined" onClick={() => onCargar('ectoparasitos')}>
        Ectoparásitos
      </Button>
    </Box>
  );
}
